import { Box } from '@/shared/ui';

import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';
import { TABNAME_MAX_LENGTH } from '@/features/dashboard/constants/const';
import { NameInput } from '@/shared/ui/primitives/NameInput';
import Typography from '@/shared/ui/typography/Text';

export const TabName = () => {
  const { form, setCanPreview } = useAppForm();
  return (
    <Box
      sx={{
        backgroundColor: 'gx.tileDark',
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        pb: 3
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: '14px', mb: 1 }}>Tab title</Typography>
      <Typography sx={{ fontWeight: 500, fontSize: '12px', color: 'gx.textDisabled', mb: 2 }}>
        Give your tab a meaningful name
      </Typography>
      <form.Field
        children={field => (
          <NameInput
            error={form.state.errorMap.onChange?.name}
            maxLength={TABNAME_MAX_LENGTH}
            value={field.state.value}
            onBlur={() => {
              setCanPreview(true);
            }}
            onChange={field.handleChange}
            onFocus={() => {
              setCanPreview(false);
            }}
            {...field}
          />
        )}
        name='name'
      />
    </Box>
  );
};
